// extracted by mini-css-extract-plugin
export default {"preview":"CommentPreview_preview__AklU5","previewLink":"CommentPreview_previewLink__q7ZcQ","previewMention":"CommentPreview_previewMention__U8sbQ"};